module.exports = "/static/assets/b5a010c5cfdd5526e177a8330beae1d5.png";